import { useEffect, useState } from "react";
import { MIN_KEYBOARD_HEIGHT } from "./keyboard";
const DEFAULT_VALUE = false;
const useDetectKeyboardOpen = ({ minKeyboardHeight = MIN_KEYBOARD_HEIGHT, defaultValue = DEFAULT_VALUE } = {
    minKeyboardHeight: MIN_KEYBOARD_HEIGHT,
    defaultValue: DEFAULT_VALUE,
}) => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultValue);
    useEffect(() => {
        const listener = () => {
            const newState = (window.visualViewport?.height && window.screen.height - minKeyboardHeight > window.visualViewport.height) ||
                false;
            if (isKeyboardOpen !== newState) {
                setIsKeyboardOpen(newState);
            }
        };
        if (typeof visualViewport !== "undefined") {
            window.visualViewport?.addEventListener("resize", listener);
        }
        return () => {
            if (typeof visualViewport !== "undefined") {
                window.visualViewport?.removeEventListener("resize", listener);
            }
        };
    }, [isKeyboardOpen, minKeyboardHeight]);
    return isKeyboardOpen;
};
export { useDetectKeyboardOpen };
